var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 0L7.51031 5L9.99993 10L15.2959 8.22488L17.071 2.92891C15.2613 1.1193 12.7614 0 9.99993 0V0Z",
    fill: "#FFE278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.44079 0 4.88157 0.976328 2.92896 2.92895L4.70407 8.22492L10 10V0Z",
    fill: "#B0D16F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92895 2.92896C1.1193 4.73861 0 7.23861 0 10L5 12.4896L10 10L2.92895 2.92896Z",
    fill: "#45C5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 12.5592 0.976328 15.1184 2.92895 17.0711L8.22492 15.2959L10 10H0Z",
    fill: "#0CA8ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92896 17.0711C4.73861 18.8807 7.23861 20 10 20L12.4896 15L10 10L2.92896 17.0711Z",
    fill: "#1365C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C12.5592 20 15.1184 19.0237 17.0711 17.0711L15.2959 11.7751L10 10V20Z",
    fill: "#F71E78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 17.0711C18.8807 15.2614 20 12.7614 20 9.99999L15 7.51038L10 9.99999L17.0711 17.0711Z",
    fill: "#FF776B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 2.92896L10 10H20C20 7.4408 19.0237 4.88158 17.0711 2.92896Z",
    fill: "#FFB54C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.ca1c233cfbd1170119ea49153b81ef7f.svg";
export { ForwardRef as ReactComponent };